import React from "react";
import ReactModal from "react-modal";
import styled from "styled-components";
import { color, borderRadius, elevation, layer } from "@conserveit/blocks";
import { DIMENSIONS } from "../../../components/AppChrome/App.constants";

const Modal = ({ className, children, ...props }) => (
  <ReactModal
    ariaHideApp={false}
    className="Modal-content"
    overlayClassName={className}
    openTimeoutMS={0}
    modalStyle={{
      content: {
        transform: null,
      },
    }}
    {...props}
  >
    {children}
  </ReactModal>
);

const $Modal = styled(Modal)`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  /* hex will NOT be compiled into rgb, so the following code is not working */
  /* background-color: rgba(${color.theme.typography.ink}, 0.9); */
  background-color: rgba(55, 64, 71, 0.9);
  z-index: ${layer.fixedContent};

  .Modal-content {
    position: absolute;
    top: ${DIMENSIONS.MODAL.OFFSET_TOP};
    left: 0;
    right: 0;
    min-height: ${DIMENSIONS.MODAL.MIN_HEIGHT};
    height: calc(
      100vh - ${DIMENSIONS.MODAL.OFFSET_TOP} - ${DIMENSIONS.MODAL.OFFSET_TOP}
    );
    max-height: calc(
      100vh - ${DIMENSIONS.MODAL.OFFSET_TOP} - ${DIMENSIONS.MODAL.OFFSET_TOP}
    );
    width: 100%;
    max-width: ${DIMENSIONS.MODAL.MAX_WIDTH};
    min-width: ${DIMENSIONS.MODAL.MIN_WIDTH};
    margin: auto;
    border-radius: ${borderRadius.large};
    background: ${color.pureWhite};
    box-shadow: ${elevation.modal};
    transform: none;
    overflow: hidden;

    &:focus {
      outline: 0;
    }
  }
`;

export default $Modal;
